import { GAEvent, GAEventData } from '../types/global'
import { computeItemIdFields } from './analytics-helpers'

// Root-level keys lifted out of the ecommerce_ga4 nested object so sGTM
// "Event Data" resolvers can see them. button_type was the original; em/gclid/
// fbc/fbp are attribution match keys consumed by Meta CAPI userDataList and
// Stape Conversion Improver Enhanced Conversions matching.
const ROOT_PROPERTIES = ['button_type', 'em', 'gclid', 'fbc', 'fbp'] as const

/** Pure builder for the GA4 dataLayer payload. Extracted from project/api.ts
 *  so it can be unit-tested without dragging the full API surface (which
 *  pulls Tenant config + build-time resolved imports) into the test env. */
export function buildAnalyticsPayload(
  event: GAEvent | undefined,
  data?: GAEventData,
) {
  const { item_id, item_ids } = computeItemIdFields(data)
  const rootData: Record<string, unknown> = {}
  const ecommerceData = { ...data } as Record<string, unknown>

  ROOT_PROPERTIES.forEach((prop) => {
    if (data && prop in data) {
      const value = (data as Record<string, unknown>)[prop]
      // Empty/undefined match keys must be omitted — Stape FB CAPI sends
      // empty strings as-is which degrades Meta Event Match Quality.
      if (value !== undefined && value !== '') {
        rootData[prop] = value
      }
      delete ecommerceData[prop]
    }
  })

  return {
    ecommerce_ga4: ecommerceData,
    event,
    item_id,
    ...(item_ids ? { item_ids } : {}),
    ...rootData,
  }
}
